export default __webpack_public_path__ + "static/media/svg-whatsapp.a1c0a1e0.svg";